export default __webpack_public_path__ + "static/media/illustration8-min.e010a935.webp";